import { IBestDataset } from '../../../../../../types/analytics';
import { useWaveSpectraDateRange } from '../../../hooks/shared/useWaveSpectraDateRange';
import { DatasetSelect } from '../../common/DatasetSelect';
import { DateField } from '../../common/DateField';
import styles from '../../Layout/AnalyticsLayout.module.scss';

interface WaveSpectraInputFormProps {
  datasets: IBestDataset[];
  datasetId: string;
  onDatasetChange: (datasetId: string) => void;
  dateRange: ReturnType<typeof useWaveSpectraDateRange>;
  isLoading: boolean;
  isAvailable: boolean;
}

export const WaveSpectraInputForm = ({
  datasets,
  datasetId,
  onDatasetChange,
  dateRange,
  isLoading,
  isAvailable,
}: WaveSpectraInputFormProps) => (
  <div className={styles.formRow}>
    <DatasetSelect
      id='Analytics-WaveSpectra-Dataset_Input'
      datasets={datasets}
      value={datasetId}
      onChange={onDatasetChange}
      disabled={isLoading}
    />
    <DateField
      label='Start Date'
      testId='Analytics-StartDate_Input'
      value={dateRange.startDate}
      onChange={dateRange.onStartDateChange}
      disabledDate={dateRange.disabledStartDate}
      disabled={isLoading || !isAvailable}
    />
    <DateField
      label='End Date'
      testId='Analytics-EndDate_Input'
      value={dateRange.endDate}
      onChange={dateRange.onEndDateChange}
      disabledDate={dateRange.disabledEndDate}
      disabled={isLoading || !isAvailable}
    />
  </div>
);
